import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal, View } from 'react-native';
import { CoreConfig } from '../../../CoreConfig';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { IShareScreenViewModelType } from './IShareScreenViewModel';
import { CoreRoutes } from '../../Coordinator/Coordinator/CoreRoutes';
import { useRouteParams } from '../../Hooks/UseRouteParams';
import { component } from '../../Decorators/Component';
import { CardView } from '../../Components/Cards/CardView';
import { HeaderView } from '../../Components/Navigation/HeaderView';
import { ShareComponent } from '../../Components/Share/ShareComponent';
import { useColorScheme } from '../../Hooks/UseColorScheme';
export const ShareScreenComponent = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.shareScreen,
    dependencies: {
        viewModel: IShareScreenViewModelType
    },
    style(theme, mediaQuery, window) {
        return {
            container: {
                flex: 1,
                justifyContent: 'center',
                alignItems: 'center'
            },
            modal: {},
            card: Object.assign(Object.assign({ maxWidth: window.width - 40 }, mediaQuery.sm({
                maxWidth: 400
            })), { width: '100%' }),
            content: {
                paddingVertical: 0,
                paddingHorizontal: 0
            },
            header: {},
            body: {
                paddingHorizontal: 20,
                paddingBottom: 10
            },
            title: {
                textAlign: 'center',
                marginBottom: 20
            }
        };
    }
})(({ style, viewModel, localization }) => {
    const [params] = useRouteParams(CoreRoutes.share);
    const color_scheme = useColorScheme();
    return (_jsx(Modal, { style: style === null || style === void 0 ? void 0 : style.modal, transparent: true, statusBarTranslucent: true, visible: true, animationType: 'fade', children: _jsx(View, { style: style === null || style === void 0 ? void 0 : style.container, children: _jsxs(CardView, { containerStyles: style === null || style === void 0 ? void 0 : style.card, bodyStyles: style === null || style === void 0 ? void 0 : style.content, children: [_jsx(HeaderView, { onBack: viewModel === null || viewModel === void 0 ? void 0 : viewModel.dismiss, isDismissButton: true, reverseHeader: true, title: (localization === null || localization === void 0 ? void 0 : localization.title) || (localization === null || localization === void 0 ? void 0 : localization.share) || 'Share', tintColor: color_scheme.scheme === 'dark' && '#fff', containerStyle: style === null || style === void 0 ? void 0 : style.header }), _jsx(ShareComponent, { text: params.text, options: { title: params.title, subject: params.subject }, containerStyle: style === null || style === void 0 ? void 0 : style.body, onPress: viewModel === null || viewModel === void 0 ? void 0 : viewModel.submit })] }) }) }));
});
